var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCompass = function SvgCompass(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "27 -36 353 372",
    style: {
      enableBackground: "new 27 -36 353 372"
    },
    xmlSpace: "preserve",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    opacity: 0.1,
    d: "M203.5,287.3c-75.7,0-137.3-61.6-137.3-137.3S127.8,12.7,203.5,12.7S340.8,74.3,340.8,150 S279.2,287.3,203.5,287.3z M203.5,42.1C144,42.1,95.6,90.5,95.6,150S144,257.9,203.5,257.9S311.4,209.5,311.4,150 S263,42.1,203.5,42.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#276338",
    d: "M237.2,147.9l-32.6-69.2c-0.4-0.9-1.7-0.9-2.2,0L169.7,148c-0.3,0.6-0.4,1.3-0.4,2h68.4 C237.7,149.3,237.5,148.6,237.2,147.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#939496",
    d: "M237.2,152l-32.6,69.2c-0.4,0.9-1.7,0.9-2.2,0l-32.7-69.3c-0.3-0.6-0.4-1.3-0.4-2h68.4 C237.7,150.7,237.5,151.4,237.2,152z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M128.8,52.7c-63.9,49.5-63.9,145.1,0,194.6c43.5,33.8,105.9,33.8,149.5,0c63.9-49.5,63.9-145.1,0-194.6 C234.7,18.9,172.3,18.9,128.8,52.7z M237.2,152l-32.6,69.2c-0.4,0.9-1.7,0.9-2.2,0l-32.7-69.3c-0.6-1.3-0.6-2.7,0-4l32.7-69.3 c0.4-0.9,1.7-0.9,2.2,0l32.6,69.2C237.8,149.2,237.8,150.7,237.2,152z M210.4,156.9c4.2-4.2,4.2-9.7,0-13.9s-9.7-4.2-13.9,0 c-4.2,4.2-4.2,9.7,0,13.9C200.7,161.1,206.3,161.1,210.4,156.9z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCompass);
export default ForwardRef;